const initialState = {
  fetching: false,
};

export default function planAssignmentReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'PLAN_ASSIGNING':
      return { ...currentState, fetching: true };
    case 'PLAN_ASSIGNMENT_FETCHING':
      return { ...currentState, fetching: true };
    case 'PLAN_ASSIGNED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'PLAN_ASSIGNMENT_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
